export default "__VITE_ASSET__CLz7BEBo__"